export default __webpack_public_path__ + "static/media/Button-Drawings.520edcb5.svg";